// extracted by mini-css-extract-plugin
export default {"root":"BiddingForm_root__kCBT6","error":"BiddingForm_error__hD3AD","input":"BiddingForm_input__IvzLy","submitButton":"BiddingForm_submitButton__NdbGX"};